$(document).on('click', '.search__trigger, .search__close, .js-show-search', function(e) {
  e.preventDefault();
  $('body').toggleClass('search--show');
  $('.search__input').focus();
})



function isTouchDevice() {
  return (('ontouchstart' in window) ||
     (navigator.maxTouchPoints > 0) ||
     (navigator.msMaxTouchPoints > 0));
}

function productHover(parent) {
  // parent.querySelectorAll(".product-item").forEach(function(el){
  //   var hoverTl = gsap.timeline({
  //     paused: true,
  //   });

  //   hoverTl.fromTo(el.querySelector(".product-img"), {
  //     autoAlpha: 1,
  //   }, {
  //     autoAlpha: 0,
  //     duration: .15,
  //     ease: "power2.out",
  //   }, 0);

  //   hoverTl.fromTo(el.querySelector(".product-img-hover"), {
  //     scale: 1.2,
  //   }, {
  //     scale: 1,
  //     duration: .25,
  //     ease: "power2.in"
  //   }, 0);

  //   hoverTl.fromTo(el.querySelector(".product-img-hover"), {
  //     autoAlpha: 0,
  //   }, {
  //     autoAlpha: 1,
  //     duration: .5,
  //     ease: "power2.in"
  //   }, .0);

  //   el.addEventListener('mouseenter', function(){
  //     if(window.innerWidth >= 768) hoverTl.play();
  //   });
  //   el.addEventListener('mouseleave', function(){
  //     if(window.innerWidth >= 768) hoverTl.reverse();
  //   });
  // });
}